import { useLang } from "@/context/LanguageContext";
import { Sparkles, MoveRight } from "lucide-react";
import { NALJURI_PHOTOS } from "@/lib/photos";

// Real Naljuri-area photographs (NO AI imagery)
const SADAPATHOR_HERO = NALJURI_PHOTOS.SADAPATHOR;
const SADAPATHOR_DETAIL = NALJURI_PHOTOS.RONGPANI;

export default function Sadapathor() {
  const { t, lang } = useLang();

  return (
    <section className="bg-cream-100 border-y border-forest-100" data-testid="sadapathor-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-6 flex flex-col justify-center">
            <p className="eyebrow tag-line">{t.sadapathor.eyebrow}</p>
            <h2 className={`mt-5 font-display text-forest-700 tracking-tight leading-[1.05] ${lang==='bn'?'font-bn':''}`}
                data-testid="sadapathor-title"
                style={{ fontSize: 'clamp(2.2rem, 4.8vw, 4rem)' }}>
              {t.sadapathor.title}
            </h2>
            <div className="gold-rule mt-7" />
            <p className="mt-7 text-base md:text-lg text-slate-warm leading-relaxed max-w-xl">
              {t.sadapathor.sub}
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {t.sadapathor.tags.map((tag, i) => (
                <span key={i} className="text-[11px] uppercase tracking-widest2 text-forest-700 border border-gold-600/40 bg-gold-50 px-3 py-1.5 rounded-full"
                      data-testid={`sadapathor-tag-${i}`}>
                  {tag}
                </span>
              ))}
            </div>
            <a href="#booking" data-testid="sadapathor-cta"
               className="mt-10 group inline-flex items-center gap-2 self-start bg-forest-700 text-cream-100 px-7 py-3.5 rounded-full text-sm hover:bg-forest-800 transition-all hover:gap-4 border border-gold-600/40">
              <Sparkles className="w-4 h-4 text-gold-400" /> {t.sadapathor.cta}
              <MoveRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <div className="lg:col-span-6 grid grid-cols-2 gap-4">
            <div className="col-span-2 group overflow-hidden rounded-md border border-forest-100">
              <img src={SADAPATHOR_HERO} alt="Sadapathor crystal turquoise water"
                   className="w-full h-[360px] md:h-[420px] object-cover img-zoom" loading="lazy" />
            </div>
            <div className="group overflow-hidden rounded-md border border-forest-100">
              <img src={SADAPATHOR_DETAIL} alt="Coloured stones beneath clear water"
                   className="w-full h-44 object-cover img-zoom" loading="lazy" />
            </div>
            <div className="rounded-md border border-forest-100 p-5 bg-white flex flex-col justify-center">
              <div className="text-[10px] uppercase tracking-widest2 text-gold-600">Heritage</div>
              <div className={`mt-3 text-base font-display text-forest-700 leading-snug ${lang==='bn'?'font-bn':''}`}>
                {lang === 'en'
                  ? "Pebble-painting is a 200-year-old Khasi tradition. We'll arrange a private session."
                  : "নুড়ি দিয়ে ছবি আঁকা একটি ২০০ বছরের পুরনো খাসি ঐতিহ্য। আমরা আপনার জন্য ব্যক্তিগত সেশন আয়োজন করব।"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
